import { removeElement } from '../dom'
import { getFabricDependencies } from '../fabric-dependencies'
import { removeWindowEventListener } from '../utils'

import {
  beforeUnload,
  getRenderAppElementId,
  SURFACE_DATA_ATTRIBUTE_NAME,
} from './helpers'
import { runCleanup } from './state'

const removeSurfaceInternal = () => {
  const surfaceElement = document.getElementById(getRenderAppElementId())
  if (surfaceElement) {
    getFabricDependencies()?.unmountComponentAtNode(surfaceElement)
  }

  // cleanup/remove relevant elements from DOM
  const renderRootContainer = surfaceElement && surfaceElement.parentElement

  if (
    renderRootContainer &&
    renderRootContainer.getAttribute(SURFACE_DATA_ATTRIBUTE_NAME)
  ) {
    removeElement(renderRootContainer)
  }
}

export const removeSurface = (clearListener = false) => {
  if (clearListener) {
    removeWindowEventListener('beforeunload', beforeUnload)
  }

  runCleanup()

  removeSurfaceInternal()
}
